import Alpine from "alpinejs"

Alpine.data("form", () => ({
    init() {
        if (location.search.includes("validate=true")) {
            this.$nextTick(() => {
                this.$el.querySelectorAll("[aria-invalid='true']").forEach((field) => {
                    field.setCustomValidity(document.getElementById(`${field.id}_errors`).textContent)
                    const change = field.addEventListener("change", () => {
                        field.setCustomValidity("")
                        field.removeEventListener("change", change)
                    })
                })
                this.$el.reportValidity()
            })
        }
    },
}))

// Custom form field component Validation / Hinting
Alpine.data("formField", (config = {}) => ({
    // Configuration with defaults
    fieldName: config.fieldName || "copy",
    minLength: config.minLength || 3,
    maxLength: config.maxLength || 100,
    showCounter: config.showCounter !== false,
    customErrorMessages: config.errorMessages || {},

    // Initialize method
    init() {
        if (typeof this.formData === "undefined") {
            this.formData = {}
        }
        if (typeof this.formData[this.fieldName] === "undefined") {
            this.formData[this.fieldName] = ""
        }
    },

    // Computed properties
    get fieldValue() {
        return this.formData[this.fieldName]?.length || 0
    },

    get hasValidationError() {
        return (this.fieldValue > 0 && this.fieldValue < this.minLength) || this.fieldValue > this.maxLength
    },

    get isTextTooLong() {
        return this.fieldValue > this.maxLength
    },

    get isTextTooShort() {
        return this.fieldValue > 0 && this.fieldValue < this.minLength
    },

    get characterCount() {
        return `${this.fieldValue}/${this.maxLength}`
    },

    get shouldShowCounter() {
        return this.showCounter
    },

    get errorTextToLong() {
        return this.customErrorMessages.tooLong || `Maximum ${this.maxLength} characters allowed`
    },

    get errorTextToShort() {
        return this.customErrorMessages.tooShort || `Minimum ${this.minLength} characters required`
    },

    // Utility methods
    validate() {
        return !this.hasValidationError
    },

    reset() {
        this.formData[this.fieldName] = ""
    },
}))
